import { useQuery } from 'react-query';
import request from '../../../helpers/request';

export const getBinds = async (infoId) => {
  return await request.get(
    `/Information/binds/${infoId}`,
    {},
    'При запросе привязок произошла ошибка'
  );
};

export const createInfoBindKey = (infoId) => ['infoBinds', infoId];

const useInfoBinds = (infoId, options) =>
  useQuery(createInfoBindKey(infoId), () => getBinds(infoId), options);

export default useInfoBinds;
